<!-- components/BlockchainStats.vue -->
<template>
  <div class="flex gap-3">
    <div class="bg-blue-50 p-3 rounded-lg flex-1 border border-blue-100 shadow-sm hover:shadow-md transition-shadow duration-200">
      <div class="flex items-center mb-1">
        <i class="fas fa-link text-blue-400 mr-2 text-xs" />
        <h4 class="text-xs font-medium text-gray-500 uppercase tracking-wide">
          Chain ID
        </h4>
      </div>
      <p class="text-sm font-semibold text-blue-700 truncate">
        {{ loading ? "Loading..." : chainId }}
      </p>
    </div>
    <div class="bg-blue-50 p-3 rounded-lg flex-1 border border-blue-100 shadow-sm hover:shadow-md transition-shadow duration-200">
      <div class="flex items-center mb-1">
        <i class="fas fa-cube text-blue-400 mr-2 text-xs" />
        <h4 class="text-xs font-medium text-gray-500 uppercase tracking-wide">
          Latest Block
        </h4>
      </div>
      <p class="text-sm font-semibold text-blue-700 truncate">
        {{ loading ? "Loading..." : height }}
      </p>
    </div>
  </div>
</template>
  
  <script>
  export default {
    name: "BlockchainStats",
    props: {
      apiEndpoint: {
        type: String,
        required: true
      },
      refreshInterval: {
        type: Number,
        default: 15000 // Default to 15 seconds
      }
    },
    data() {
      return {
        chainId: null,
        height: null,
        loading: true,
        error: null,
        intervalId: null
      };
    },
    mounted() {
      // Initial fetch
      this.fetchBlockchainData();
      
      // Set up interval for periodic updates
      this.intervalId = setInterval(() => {
        this.fetchBlockchainData();
      }, this.refreshInterval);
    },
    beforeUnmount() {
      // Clear interval when component is destroyed
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    },
    methods: {
      async fetchBlockchainData() {
        this.loading = true;
        try {
          const response = await fetch(this.apiEndpoint);
          if (!response.ok) {
            throw new Error(`API responded with status: ${response.status}`);
          }
          
          const data = await response.json();
          
          // Extract the chain_id and height from the response
          if (data && data.block && data.block.header) {
            this.chainId = data.block.header.chain_id;
            this.height = data.block.header.height;
            console.log("Blockchain data updated:", { chainId: this.chainId, height: this.height });
          } else {
            throw new Error("Unexpected API response structure");
          }
        } catch (error) {
          console.error("Error fetching blockchain data:", error);
          this.error = error.message;
        } finally {
          this.loading = false;
        }
      }
    }
  };
  </script>